import { array, string } from 'yup';

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const INVALID_EMAIL_MESSAGE = 'Please enter a valid email address';

export const DUPLICATE_EMAIL_MESSAGE = 'This email already exists';

const normalizeEmail = (email) => (email ?? '').trim().toLowerCase();

export const isValidEmail = (email) => EMAIL_PATTERN.test((email ?? '').trim());

export const isRepeatedEmail = (emails, index) => {
    const email = normalizeEmail(emails[index]);
    return !!email && emails.slice(0, index).some((other) => normalizeEmail(other) === email);
};

export const emailListSchema = array()
    .of(
        string()
            .trim()
            .required('Email is required')
            .matches(EMAIL_PATTERN, { message: INVALID_EMAIL_MESSAGE, excludeEmptyString: true })
            .test('unique-email', DUPLICATE_EMAIL_MESSAGE, function () {
                const index = Number(this.path.match(/\[(\d+)\]$/)?.[1]);
                return !isRepeatedEmail(this.parent ?? [], index);
            })
    )
    .nullable();
